import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  id: number;
  idpId: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  studentId: string;
  has_skipped_tutorial: boolean;
  profile_image: string | null;
  selected_education: string | null;
  selected_year: string | null;
  selected_occupation: string | null;
  selected_profile_choice: string | null;
  selected_type: string | null;
}

const initialState: AuthState = {
  id: 0,
  idpId: "",
  email: "",
  firstName: "",
  lastName: "",
  role: "",
  studentId: "",
  has_skipped_tutorial: false,
  profile_image: "",
  selected_education: null,
  selected_year: null,
  selected_occupation: null,
  selected_profile_choice: null,
  selected_type: null,
};

export type PassportSelectionState = Pick<
  AuthState,
  | "selected_education"
  | "selected_year"
  | "selected_occupation"
  | "selected_profile_choice"
  | "selected_type"
>;

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUserDetails: (state, action: PayloadAction<AuthState>) => {
      state.id = action.payload.id;
      state.email = action.payload.email;
      state.firstName = action.payload.firstName;
      state.lastName = action.payload.lastName;
      state.role = action.payload.role;
      state.idpId = action.payload.idpId;
      state.studentId = action.payload.studentId;
      state.has_skipped_tutorial = action.payload.has_skipped_tutorial;
      state.profile_image = action.payload.profile_image;
      state.selected_education = action.payload.selected_education;
      state.selected_year = action.payload.selected_year;
      state.selected_occupation = action.payload.selected_occupation;
      state.selected_profile_choice = action.payload.selected_profile_choice;
      state.selected_type = action.payload.selected_type;
    },
    updatePassportSelection: (
      state,
      action: PayloadAction<Partial<PassportSelectionState>>
    ) => {
      if (action.payload.selected_education !== undefined) {
        state.selected_education = action.payload.selected_education;
      }
      if (action.payload.selected_year !== undefined) {
        state.selected_year = action.payload.selected_year;
      }
      if (action.payload.selected_occupation !== undefined) {
        state.selected_occupation = action.payload.selected_occupation;
      }
      if (action.payload.selected_profile_choice !== undefined) {
        state.selected_profile_choice = action.payload.selected_profile_choice;
      }
      if (action.payload.selected_type !== undefined) {
        state.selected_type = action.payload.selected_type;
      }
    },
  },
});

export const { setUserDetails, updatePassportSelection } = authSlice.actions;
export default authSlice.reducer;
